import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {
  color,
  device,
  fontWeight,
  H3,
  Pill,
  radius,
  shadow,
  SmallText,
  space,
} from '@ticketswap/solar'

const ImageCardContainer = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${radius.lg};
  min-height: ${space[256]};
  box-shadow: ${shadow.strong};
  display: flex;
  flex-direction: column-reverse;
  align-items: end;

  [data-theme='dark'] & {
    background-color: ${color.nova};
  }
`

const BannerContent = styled.div`
  z-index: 1;
  padding: ${space[64]} ${space[16]} ${space[16]};
  width: 100%;
  background-image: linear-gradient(
    180deg,
    rgba(0, 19, 25, 0) 0%,
    rgba(0, 19, 25, 0.07) 28%,
    rgba(0, 19, 25, 0.4) 58.21%,
    rgba(0, 19, 25, 0.9) 100%
  );

  @media ${device.tablet} {
    padding: ${space[64]} ${space[24]} ${space[24]};
  }

  h3 {
    font-weight: ${fontWeight.bold};
    color: ${color.nova};
  }

  span {
    display: block;
    color: ${color.nova};
  }

  [data-theme='dark'] & {
    span,
    h3 {
      color: ${color.space};
    }
  }
`

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.image});
`

const StyledPill = styled(Pill)`
  position: absolute;
  top: ${space[8]};
  right: ${space[8]};
  z-index: 1;
`

export const ImageCard = ({ children, image, title, text, employeeOnly, ...props }) => (
  <ImageCardContainer {...props}>
    <BannerContent>
      <H3>{title}</H3>
      {text && <SmallText>{text}</SmallText>}
    </BannerContent>
    <BackgroundImage image={image} />

    {employeeOnly && <StyledPill variant="warning">Employee only</StyledPill>}
  </ImageCardContainer>
)

ImageCard.defaultProps = {
  employeeOnly: false,
}

ImageCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  employeeOnly: PropTypes.bool,
}
